import React, { Component } from 'react';
import './Error.css';
export class Error extends Component {
   
    render() {
        return (
            <div className="mainbody">
                <div className="cards">
                    <div style={{ borderRadius: '200px', height: '200px', width: '200px', background: '#F8FAF5', margin: '0 auto' }}>
                        <i style={{ color: 'darkred' }} className="checkmark">Error</i>
                    </div>
                    <p>We received your error <br /> </p>
                </div>
            </div>
        );
    }
}    